import extractObjectFromTable from './extract-object-table';

const getImageArray = (html: any) => {
  let contentDiv = html;

  if (typeof (html) === 'string') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    contentDiv = doc.querySelector('table');
  }

  if (contentDiv instanceof Element) {
    const rows = Array.from(contentDiv.querySelectorAll('tr'));

    const filteredContent = rows.filter((tr) => {
      const parentElement = tr.parentNode as Element;
      const greatParentElement = parentElement.parentNode as Element;
      return !greatParentElement.classList.contains('midiaImagem');
    });

    const images: any[] = [];

    filteredContent.forEach((row: any) => {
      const cells = row.querySelectorAll('td');

      if (cells.length >= 2) {
        const image = extractObjectFromTable(cells[1]);
        images.push(image);
      }
    });

    return images;
  }

  return null;
};

export default getImageArray;
